<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Request Details</h5>
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Function</b></label>
              <p>{{ ApproveRequest?.departmentName }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Location</b></label>
              <p>{{ ApproveRequest?.locationName }}</p>
            </div>

            <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ ApproveRequest?.costCenterName }}</p>
            </div>
          </div>
        </div>

        <hr>

        <!-- Non Editable View -->
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Contract Duration (Month)</b></label>
              <p>{{ ApproveRequest?.contractDuration }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ ApproveRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Number of Staff</b></label>
              <p>{{ ApproveRequest?.noOfStaff }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Budget Cost</b></label>
              <p>{{ ApproveRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
            </div>

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ ApproveRequest?.createdBy }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Request Description</b></label>
              <p>{{ ApproveRequest?.description }}</p>
            </div>

            <div class="col">
              <label><b>Request Justification</b></label>
              <p>{{ ApproveRequest?.justification }}</p>
            </div>
          </div>


          <div class="row">

            <div class="col">
              <label><b>Request Notes</b></label>
              <p>{{ ApproveRequest?.expressApprovalRequesterMessage }}</p>
            </div>

            <div class="col">
              <label><b>Request Justification</b></label>
              <p>{{ ApproveRequest?.qualification }}</p>
            </div>
          </div>




          <div class="row">

            <div class="col">
              <label><b>Required Qualification & Experience</b></label>
              <p>{{ ApproveRequest?.qualification }}</p>
            </div>

            <div class="col">
              <label><b>Reason</b></label>
              <p>{{ ApproveRequest?.expressApprovalRequesterMessage }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template #footerTpl>

    <div style="float: left" class="d-print-none">
      <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
        (nzOnConfirm)="openApproveConfirmationModal()" (nzOnCancel)="cancel()">
        <span style="margin-right: 8px;" class="btn btn-primary">
          Approve
        </span>
      </a>
    </div>

    <div style="float: left" class="d-print-none">
      <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
        (nzOnConfirm)="openRejectConfirmationModal()" (nzOnCancel)="cancel()">
        <span style="margin-right: 8px;" class="btn btn-danger">
          Reject
        </span>
      </a>
    </div>

    <div style="float: right" class="d-print-none">
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>

</nz-drawer>
<!-- Drawer -->

<!-- Approve Confirmation  Modal  -->
<nz-modal [(nzVisible)]="isApproveConfirmationModalVisible" nzTitle="Express Approval Confirmation"
  (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="Comment">Comment</label>
      <textarea class="form-control" id="Comment" rows="4" name="Comment" [(ngModel)]="Comment" required></textarea>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="approveExpressRequest()" [disabled]="isProcessing">Submit</button>
  </div>

</nz-modal>

<!-- Reject Confirmation  Modal  -->
<nz-modal [(nzVisible)]="isRejectConfirmationModalVisible" nzTitle="Express Approval Confirmation"
  (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="Comment">Comment</label>
      <textarea class="form-control" id="Comment" rows="4" name="Comment" [(ngModel)]="Comment" required></textarea>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="rejectExpressRequest()" [disabled]="isProcessing">Submit</button>
  </div>

</nz-modal>

<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title"> Express Approvals</h4>
          <div class="table-responsive pt-3">
            <table class="table table--striped table-hover">
              <thead>
                <tr>
                  <th>
                    Reference
                  </th>
                  <th>
                    Request Date
                  </th>
                  <th>
                    Request Description
                  </th>
                  <th>
                    Created By
                  </th>
                  <th *ngIf="showFunctionColumn">
                    Function
                  </th>
                  <th>
                    Location
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of Contracts" (click)="open(data)" class="clickable">
                  <td>{{data.reference}}</td>

                  <td>{{data.createdDate | date: 'dd MMMM yyyy'}}</td>

                  <td>{{data.description.substring(0,50)}} ...</td>

                  <td>{{data.createdBy}}</td>

                  <td>{{data.departmentName}}</td>

                  <td>{{data.locationName}}</td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
      </div>
    </div>


  </div>
</div>